angular.module('rjmNg.constants').constant('enums'
  DASHBOARD_PERMISSION: Object.freeze
    NONE: 0
    VIEW: 1
    EDIT: 2
)
.constant('FEATURE_TIER_NAMES'
  1: 'Starter'
  2: 'Premium'
)
.constant('FEATURE_TIER'
  BASIC: 1
  PREMIUM: 2
)
.constant('CLIENT_TYPE'
  OTHER: '0'
  ECE: '1'
  EE: '2'
  INTERNAL: '3'
  DEMO: '4'
  MOM: '5'
)
.constant('KEY_CODES'
  BACKSPACE: 8
  ENTER: 13
)
.constant('US_STATE_ABBREVS', [
  "AL"
  "AK"
  "AZ"
  "AR"
  "CA"
  "CO"
  "CT"
  "DE"
  "DC"
  "FL"
  "GA"
  "HI"
  "ID"
  "IL"
  "IN"
  "IA"
  "KS"
  "KY"
  "LA"
  "ME"
  "MD"
  "MA"
  "MI"
  "MN"
  "MS"
  "MO"
  "MT"
  "NE"
  "NV"
  "NH"
  "NJ"
  "NM"
  "NY"
  "NC"
  "ND"
  "OH"
  "OK"
  "OR"
  "PA"
  "RI"
  "SC"
  "SD"
  "TN"
  "TX"
  "UT"
  "VT"
  "VA"
  "WA"
  "WV"
  "WI"
  "WY"
])
.constant('US_STATE_NAMES', [
  "Alabama"
  "Alaska"
  "Arizona"
  "Arkansas"
  "California"
  "Colorado"
  "Connecticut"
  "Delaware"
  "District Of Columbia"
  "Florida"
  "Georgia"
  "Hawaii"
  "Idaho"
  "Illinois"
  "Indiana"
  "Iowa"
  "Kansas"
  "Kentucky"
  "Louisiana"
  "Maine"
  "Maryland"
  "Massachusetts"
  "Michigan"
  "Minnesota"
  "Mississippi"
  "Missouri"
  "Montana"
  "Nebraska"
  "Nevada"
  "New Hampshire"
  "New Jersey"
  "New Mexico"
  "New York"
  "North Carolina"
  "North Dakota"
  "Ohio"
  "Oklahoma"
  "Oregon"
  "Pennsylvania"
  "Rhode Island"
  "South Carolina"
  "South Dakota"
  "Tennessee"
  "Texas"
  "Utah"
  "Vermont"
  "Virginia"
  "Washington"
  "West Virginia"
  "Wisconsin"
  "Wyoming"
])
.constant('COUNTRY_ABBREVS', [
  "US"
  "AF"
  "AL"
  "DZ"
  "AS"
  "AD"
  "AO"
  "AI"
  "AQ"
  "AG"
  "AR"
  "AM"
  "AW"
  "AU"
  "AT"
  "AZ"
  "BS"
  "BH"
  "BD"
  "BB"
  "BY"
  "BE"
  "BZ"
  "BJ"
  "BM"
  "BT"
  "BO"
  "BA"
  "BW"
  "BV"
  "BR"
  "IO"
  "BN"
  "BG"
  "BF"
  "BI"
  "KH"
  "CM"
  "CA"
  "CV"
  "KY"
  "CF"
  "TD"
  "CL"
  "CN"
  "CX"
  "CC"
  "CO"
  "KM"
  "CG"
  "CK"
  "CR"
  "CI"
  "HR"
  "CU"
  "CY"
  "CZ"
  "CD"
  "DK"
  "DJ"
  "DM"
  "DO"
  "TP"
  "EC"
  "EG"
  "SV"
  "GQ"
  "ER"
  "EE"
  "ET"
  "FK"
  "FO"
  "FJ"
  "FI"
  "FR"
  "FX"
  "GF"
  "PF"
  "TF"
  "GA"
  "GM"
  "GE"
  "DE"
  "GH"
  "GI"
  "GR"
  "GL"
  "GD"
  "GP"
  "GU"
  "GT"
  "GN"
  "GW"
  "GY"
  "HT"
  "HM"
  "HN"
  "HK"
  "HU"
  "IS"
  "IN"
  "ID"
  "IR"
  "IQ"
  "IE"
  "IL"
  "IT"
  "JM"
  "JP"
  "JO"
  "KZ"
  "KE"
  "KI"
  "KW"
  "KG"
  "LA"
  "LV"
  "LB"
  "LS"
  "LR"
  "LY"
  "LI"
  "LT"
  "LU"
  "MO"
  "MK"
  "MG"
  "MW"
  "MY"
  "MV"
  "ML"
  "MT"
  "MH"
  "MQ"
  "MR"
  "MU"
  "YT"
  "MX"
  "FM"
  "MD"
  "MC"
  "MN"
  "MS"
  "MA"
  "MZ"
  "MM"
  "NA"
  "NR"
  "NP"
  "NL"
  "AN"
  "NC"
  "NZ"
  "NI"
  "NE"
  "NG"
  "NU"
  "NF"
  "KP"
  "MP"
  "NO"
  "OM"
  "PK"
  "PW"
  "PA"
  "PG"
  "PY"
  "PE"
  "PH"
  "PN"
  "PL"
  "PT"
  "PR"
  "QA"
  "RE"
  "RO"
  "RU"
  "RW"
  "SH"
  "KN"
  "LC"
  "PM"
  "VC"
  "SM"
  "ST"
  "SA"
  "SN"
  "SC"
  "SL"
  "SG"
  "SK"
  "SI"
  "SB"
  "SO"
  "ZA"
  "KR"
  "ES"
  "LK"
  "SD"
  "SR"
  "SJ"
  "SZ"
  "SE"
  "CH"
  "SY"
  "TW"
  "TJ"
  "TZ"
  "TH"
  "TG"
  "TK"
  "TO"
  "TT"
  "TN"
  "TR"
  "TM"
  "TC"
  "TV"
  "UG"
  "UA"
  "AE"
  "UK"
  "UM"
  "UY"
  "UZ"
  "VU"
  "VA"
  "VE"
  "VN"
  "VG"
  "VI"
  "WF"
  "EH"
  "WS"
  "YE"
  "YU"
  "ZM"
  "ZW"
])
.constant('COUNTRY_NAMES', [
  "United States"
  "Afghanistan"
  "Albania"
  "Algeria"
  "American Samoa"
  "Andorra"
  "Angola"
  "Anguilla"
  "Antarctica"
  "Antigua And Barbuda"
  "Argentina"
  "Armenia"
  "Aruba"
  "Australia"
  "Austria"
  "Azerbaijan"
  "Bahamas"
  "Bahrain"
  "Bangladesh"
  "Barbados"
  "Belarus"
  "Belgium"
  "Belize"
  "Benin"
  "Bermuda"
  "Bhutan"
  "Bolivia"
  "Bosnia And Herzegovina"
  "Botswana"
  "Bouvet Island"
  "Brazil"
  "British Indian Ocean Territory"
  "Brunei"
  "Bulgaria"
  "Burkina Faso"
  "Burundi"
  "Cambodia"
  "Cameroon"
  "Canada"
  "Cape Verde"
  "Cayman Islands"
  "Central African Republic"
  "Chad"
  "Chile"
  "China"
  "Christmas Island"
  "Cocos (Keeling) Islands"
  "Columbia"
  "Comoros"
  "Congo"
  "Cook Islands"
  "Costa Rica"
  "Cote D'Ivorie (Ivory Coast)"
  "Croatia (Hrvatska)"
  "Cuba"
  "Cyprus"
  "Czech Republic"
  "Democratic Republic Of Congo (Zaire)"
  "Denmark"
  "Djibouti"
  "Dominica"
  "Dominican Republic"
  "East Timor"
  "Ecuador"
  "Egypt"
  "El Salvador"
  "Equatorial Guinea"
  "Eritrea"
  "Estonia"
  "Ethiopia"
  "Falkland Islands (Malvinas)"
  "Faroe Islands"
  "Fiji"
  "Finland"
  "France"
  "France, Metropolitan"
  "French Guinea"
  "French Polynesia"
  "French Southern Territories"
  "Gabon"
  "Gambia"
  "Georgia"
  "Germany"
  "Ghana"
  "Gibraltar"
  "Greece"
  "Greenland"
  "Grenada"
  "Guadeloupe"
  "Guam"
  "Guatemala"
  "Guinea"
  "Guinea-Bissau"
  "Guyana"
  "Haiti"
  "Heard And McDonald Islands"
  "Honduras"
  "Hong Kong"
  "Hungary"
  "Iceland"
  "India"
  "Indonesia"
  "Iran"
  "Iraq"
  "Ireland"
  "Israel"
  "Italy"
  "Jamaica"
  "Japan"
  "Jordan"
  "Kazakhstan"
  "Kenya"
  "Kiribati"
  "Kuwait"
  "Kyrgyzstan"
  "Laos"
  "Latvia"
  "Lebanon"
  "Lesotho"
  "Liberia"
  "Libya"
  "Liechtenstein"
  "Lithuania"
  "Luxembourg"
  "Macau"
  "Macedonia"
  "Madagascar"
  "Malawi"
  "Malaysia"
  "Maldives"
  "Mali"
  "Malta"
  "Marshall Islands"
  "Martinique"
  "Mauritania"
  "Mauritius"
  "Mayotte"
  "Mexico"
  "Micronesia"
  "Moldova"
  "Monaco"
  "Mongolia"
  "Montserrat"
  "Morocco"
  "Mozambique"
  "Myanmar (Burma)"
  "Namibia"
  "Nauru"
  "Nepal"
  "Netherlands"
  "Netherlands Antilles"
  "New Caledonia"
  "New Zealand"
  "Nicaragua"
  "Niger"
  "Nigeria"
  "Niue"
  "Norfolk Island"
  "North Korea"
  "Northern Mariana Islands"
  "Norway"
  "Oman"
  "Pakistan"
  "Palau"
  "Panama"
  "Papua New Guinea"
  "Paraguay"
  "Peru"
  "Philippines"
  "Pitcairn"
  "Poland"
  "Portugal"
  "Puerto Rico"
  "Qatar"
  "Reunion"
  "Romania"
  "Russia"
  "Rwanda"
  "Saint Helena"
  "Saint Kitts And Nevis"
  "Saint Lucia"
  "Saint Pierre And Miquelon"
  "Saint Vincent And The Grenadines"
  "San Marino"
  "Sao Tome And Principe"
  "Saudi Arabia"
  "Senegal"
  "Seychelles"
  "Sierra Leone"
  "Singapore"
  "Slovak Republic"
  "Slovenia"
  "Solomon Islands"
  "Somalia"
  "South Africa"
  "South Korea"
  "Spain"
  "Sri Lanka"
  "Sudan"
  "Suriname"
  "Svalbard And Jan Mayen"
  "Swaziland"
  "Sweden"
  "Switzerland"
  "Syria"
  "Taiwan"
  "Tajikistan"
  "Tanzania"
  "Thailand"
  "Togo"
  "Tokelau"
  "Tonga"
  "Trinidad And Tobago"
  "Tunisia"
  "Turkey"
  "Turkmenistan"
  "Turks And Caicos Islands"
  "Tuvalu"
  "Uganda"
  "Ukraine"
  "United Arab Emirates"
  "United Kingdom"
  "United States Minor Outlying Islands"
  "Uruguay"
  "Uzbekistan"
  "Vanuatu"
  "Vatican City (Holy See)"
  "Venezuela"
  "Vietnam"
  "Virgin Islands (British)"
  "Virgin Islands (US)"
  "Wallis And Futuna Islands"
  "Western Sahara"
  "Western Samoa"
  "Yemen"
  "Yugoslavia"
  "Zambia"
  "Zimbabwe"
])
.constant('FORMULA_EXPRESSION_CHARACTER_LIMIT', 600)
.constant('modelRequestEnum',
  TIMEOUTS: Object.freeze
    REQUEST_TIMEOUT_SECS: 10 # seconds to wait before 'Calculating...' warning
    MAX_POLLING_INTERVAL_SECS: 32 # max interval to poll for fresh chart/figure data
)
.constant('DEMO_CLIENT_ID', 2251)
.constant('MOBILE_WIDTH', 768)

.constant('SCATTER_PLOT_POINTS_ENUMS'
  RADIUS: 6
  LINE_WIDTH: 1
  FILL_COLOR: 'rgba(179, 226, 255, 0.5)'
  TREND_LINE_RADUIS: 0
  TREND_LINE_SERIES_COLOR: '#295B83'
  STEP: 1
)

.constant('HEAT_MAP_ENUMS'
  MIN_COLOR: '#D1B3FF'
  MAX_COLOR: '#3D0099'
  BORDER_WIDTH: 2
  BORDER_COLOR: '#FFFFFF'
  DATA_LABEL_COLOR: "#FFFFFF"
  NULL_COLOR: "#FFFFFF"
  LINE_WIDTH: 0
  FONT_SIZE: '14'
  TEXT_SHADOW: '#000000'
)
